import { WhiteboardsService } from "./whiteboards-service";
import { WhiteboardsUserSettingsService } from "./whiteboards-user-settings-service";

const mod = angular.module("whiteboardsCore", []);

mod.service("WhiteboardsService", WhiteboardsService);
mod.service("WhiteboardsUserSettingsService", WhiteboardsUserSettingsService);

export default mod.name;
